export interface ThunderDotStyle {
  sizePx: number;
  className: string;
}

export function thunderDotStyle(popPct: number): ThunderDotStyle | null {
  if (popPct < 15) {
    return null;
  }
  if (popPct < 30) {
    return { sizePx: 3, className: "bg-weather-thunder-low opacity-70" };
  }
  if (popPct < 50) {
    return { sizePx: 4, className: "bg-weather-thunder-30" };
  }
  if (popPct < 70) {
    return { sizePx: 4, className: "bg-weather-thunder-50" };
  }
  if (popPct < 85) {
    return { sizePx: 5, className: "bg-weather-thunder-70" };
  }
  return { sizePx: 5, className: "bg-weather-thunder-85" };
}
